import {cva} from 'class-variance-authority'

export {default as Toast} from './ToastShadcn.vue'
export {default as ToastAction} from './ToastActionShadcn.vue'
export {default as ToastClose} from './ToastCloseShadcn.vue'
export {default as ToastDescription} from './ToastDescriptionShadcn.vue'
export {default as Toaster} from './ToasterShadcn.vue'
export {default as ToastProvider} from './ToastProviderShadcn.vue'
export {default as ToastTitle} from './ToastTitleShadcn.vue'
export {default as ToastViewport} from './ToastViewportShadcn.vue'
export {toast, useToast} from './use-toast'

export const toastVariants = cva(
  'group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[--radix-toast-swipe-end-x] data-[swipe=move]:translate-x-[--radix-toast-swipe-move-x] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full',
  {
    variants: {
      variant: {
        default: 'border bg-background text-foreground',
        destructive:
          'destructive group border-destructive bg-destructive text-destructive-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
) 